import { Component, Injector, OnInit } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';

import { InfoOption } from '../../components/info/info.component';
import { FormControlOption } from '@app/forms/subscription/definition/interface/formControlOption.interface';
import { SubscriptionFacadeService } from '../../services/subscription-facade.service';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';
import { catchError } from 'rxjs';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: 'investment-objective-heritage',
    templateUrl: './investment-objective-heritage.component.html',
    styleUrls: ['./investment-objective-heritage.component.scss'],
    standalone: false
})
export class InvestmentObjectiveHeritageComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  optionInfo1: InfoOption = {
    icon: 'warning',
    backgroundColor: '#fae4e4',
    iconColor: '#a00d0d',
    textColor: '#a00d0d',
  };
  options: FormControlOption[] = [];
  isSubmitting: boolean = false;
  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
    protected injector: Injector,
  ) {
    super(formConstructor);
    this.options =
      this.subscriptionFacade?.getPledgeOptions()?.investmentGoalsOptions;
  }

  ngOnInit() {
    this.subscriptionFacade.initForm(this);
  }

  onSubmit() {
    this.form.markAsDirty();
    this.displayErrors();

    if (this.form.valid) {
      const pledge = this.subscriptionFacade.getPledge();
      const { accountInformations } = this.extract() || {};
      pledge.accountInformations = {
        ...pledge?.accountInformations,
        ...accountInformations,
      };
      this.isSubmitting = true;
      this.subscriptionFacade
        .putPledge({ ...pledge })
        .pipe(
          untilDestroyed(this),

          catchError(err => {
            this.isSubmitting = false;
            return err;
          }),
        )
        .subscribe(data => {
          this.isSubmitting = false;
          this.subscriptionFacade.nextStep();
        });
    }
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
